import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import ReactMultiSelectWrapper from '../../common/ReactMultiSelectWrapper';
import Select from '../../common/Select';
import DatePicker from '../../common/DatePicker';
import Currency from '../../common/Currency';
import '../../css/forms/default-forms.css';
import {basic as fields, job_summary, subtotals} from './fields';
import {getList, getContactsByProjectId} from '../../api/projects';
import {fetchAllQuotes} from '../../api/quotes';

import {processFields} from '../../utils/prePost';
import {validateFields} from '../../utils/validate';
import {createQuote} from '../../api/quotes';
import TextArea from '../../common/TextArea';
import CKEditorComponent from "../../сomponents/CKEditor";
import PopUp from '../../common/PopUp';
import CheckBox from '../../common/CheckBox';
import {getSalesPersonsListAll} from "../../api/task";

export class QuoteAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.cancel = this.cancel.bind(this);
    this.parseContactList = this.parseContactList.bind(this);
    this.ckeEditorScopeOfWordRef = element => {
      this.scopeOfWordRef = element;
    };
    this.ckeEditorSubtotalsRef = element => {
      this.subtotalsRef = element;
    };
    this.handleAddContacts = this.handleAddContacts.bind(this);

  }

  componentWillMount() {
    this.props.getCustomerList();
    this.props.getQuoteList();
    this.props.getSalesPersonsList();
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);
      data.scope_of_work = this.scopeOfWordRef.editor.getData();
      data.subtotals = this.subtotalsRef.editor.getData();
      data.total_amount = data.total_amount.replace(',', '');
      data.amount_tbd = data.amount_tbd ? 1 : 0;
      let dataToSend = {
        quote: data,
        project_id: data.customer,
        contacts: data.contacts,
      };
      delete dataToSend.quote.customer;
      dataToSend.quote = JSON.stringify(dataToSend.quote);
      this.props.saveForm(dataToSend);
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field == 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    if (field == 'customer') {
      const customerList = this.parseCustomersList(path(['projects', 'list'], this.props));
      const selectedCustomer = customerList.find((value) => value.value === newObject.value);
      if (selectedCustomer) {
        const customerLabel = selectedCustomer.label.split(" ")[0];
        stateClone.fields.name.value = `${customerLabel} (RFQ)`;
        this.props.getContactList(selectedCustomer.value);
      } else {
        this.props.getContactList(undefined);
      }
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToQuote();
  }

  getStatuses() {
    return [
      {
        value: 1,
        text: 'New',
      },
      {
        value: 2,
        text: 'Pending',
      },
      {
        value: 3,
        text: 'Approved',
      },
      {
        value: 4,
        text: 'Approved by customer',
      },
      {
        value: 5,
        text: 'Declined',
      },
      {
        value: 6,
        text: 'Canceled',
      },
    ];
  }

  parseCustomersList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          label: arr[i].name,
        });
      }
    }

    return arrCustomers;
  }

  parseContactList(arr) {
    const arrContacts = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        let type = arr[i].type.join('/');
        type = type ? ` (${type})`:type;
        const phone = arr[i].phone ? `, tel.: ${arr[i].phone}`: '';
        const email = arr[i].email ? `, email.: ${arr[i].email}`: '';

        arrContacts.push({
          value: arr[i].id,
          label: `${arr[i].firstname} ${arr[i].lastname}${phone}${email}${type}`,
          name: `${arr[i].firstname} ${arr[i].lastname}`
        });
      }
    }

    return arrContacts;
  }
  handleAddContacts() {
    const selectedCustomer = this.state.fields['customer'].value;
    const { goToCustomer } = this.props;
    goToCustomer(selectedCustomer);
  }
  parseSalesPersonsList(salesPersonsList) {
    return (salesPersonsList || []).map((item) => ({
      value: item.id,
      label: `${item.firstname} ${item.lastname}`,
    }));
  }
  render() {
    const disableTotalAmount = this.state.fields['amount_tbd'].value === true || this.state.fields['amount_tbd'].value === 1;
    const customerList = this.parseCustomersList(path(['projects', 'list'], this.props));
    const contactsList = this.parseContactList(path(['projects', 'contacts'], this.props));
    const salesPersonsList = this.parseSalesPersonsList(path(['tasks', 'salesPersonsList'], this.props));
    const selectedCustomer = this.state.fields['customer'].value;

    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
            {url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard'},
            {url: '/pages/quotes', icon: 'format_quote', name: 'Quotes'},
            {icon: 'add_to_photos', name: 'Add Quotes'},
          ]}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Quote
            </div>
            <div className="card-block">
              <div className="col-12" style={{paddingBottom: '40px'}}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{marginLeft: '10px'}}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{paddingLeft: '3px'}}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{paddingLeft: '3px'}}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <ReactSelectWrapper
                    options={customerList}
                    field={this.state.fields['customer']}
                    onChange={this.changeFormValue}
                  />
                  {contactsList && contactsList.length && (<ReactMultiSelectWrapper
                    options={contactsList}
                    autoFocus={false}
                    field={this.state.fields['contacts']}
                    onChange={this.changeFormValue}
                    transformSelected={o => ({...o, title: o.label, label: o.name})}
                />) || null}

                  {selectedCustomer && (<PopUp
                      id={'CustomerContactmissing'}
                      show={selectedCustomer && contactsList && contactsList.length === 0}
                      title={'Customer Contact missing'}
                      onAddContacts={this.handleAddContacts}
                      content={'There are no contacts assigned to the selected Customer. Please add at least one Contact to Proceed'}
                      yesCaption={'Manage Customer Contacts'}
                  />)}
                  <ReactSelectWrapper
                    options={salesPersonsList}
                    className={'col-12'}
                    autoFocus={false}
                    field={this.state.fields['sales_rep']}
                    onChange={this.changeFormValue}
                  />
                  <DatePicker
                    field={this.state.fields['estimate_date']}
                    onChange={this.changeFormValue}
                  />
                  <Select
                    options={this.getStatuses()}
                    field={this.state.fields['status']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['name']}
                    onChange={this.changeFormValue}
                  />
                  <TextArea
                    field={this.state.fields['description']}
                    onChange={this.changeFormValue}
                  />
                  <CKEditorComponent
                    field={this.state.fields['scope_of_work']}
                    refLink={this.ckeEditorScopeOfWordRef}
                  />
                  <div style={{marginTop: '20px', marginBottom: '20px'}}>
                    <CKEditorComponent
                      field={this.state.fields['subtotals']}
                      refLink={this.ckeEditorSubtotalsRef}
                    />
                  </div>
                  <div className="d-flex">
                  <div className="flex-fill">
                    <Currency
                      disabled={disableTotalAmount}
                      field={this.state.fields['total_amount']}
                      onChange={this.changeFormValue}
                    />
                  </div>
                  <div className="align-self-end p-2">
                    <CheckBox
                      field={this.state.fields['amount_tbd']}
                      onChange={this.changeFormValue}
                    />
                  </div>
                </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveForm: (data) => {
      createQuote(data)(dispatch);
    },
    goToQuote: () => {
      dispatch(push('/pages/quotes'));
    },
    getContactList: (id) => {
      getContactsByProjectId(id)(dispatch);
    },
    getCustomerList: () => {
      getList()(dispatch);
    },
    getQuoteList: () => {
      fetchAllQuotes()(dispatch);
    },
    goToCustomer: (id) => {
      dispatch(push('/pages/edit-customer/' + id))
    },
    getSalesPersonsList: () => {
      getSalesPersonsListAll()(dispatch)
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteAdd);



// WEBPACK FOOTER //
// ./src/containers/QuoteAdd/index.js